import { create, enforce, test } from 'vest';

import type { PerformanceReviewPeriodInput } from '@/common/graphql';

export const performanceReviewFormValidator = create(({ quarter, year }: PerformanceReviewPeriodInput) => {
  test('quarter', 'Quarter is required', () => {
    enforce(quarter).isNotEmpty();
  });
  test('year', 'Year is required', () => {
    enforce(year).isNotEmpty();
  });
});
